import { apiWrapper } from "@/services/api";

export const putSurveyAnswer = async (bookGroupId, answers) => {
  await apiWrapper("PUT", `book_groups/${bookGroupId}/survey_answer`, {
    answer: answers,
  });
};
